import produce from "immer";
import { EnumTiposLocal } from "../../../../utils/mxenumerados";
import { store } from "../../../index";

export const TypesEntreposto = {
    ATUALIZAR_ETAPA: "entreposto/ATUALIZAR_ETAPA",
    ATUALIZAR_VOLUME_ORIGEM: "entreposto/ATUALIZAR_VOLUME_ORIGEM",
    ATUALIZAR_VOLUME_DESTINO: "entreposto/ATUALIZAR_VOLUME_DESTINO",
    ATUALIZAR_QUANTIDADE_REGULAR: "entreposto/ATUALIZAR_QUANTIDADE_REGULAR",
    ATUALIZAR_REMONTAGEM: "entreposto/ATUALIZAR_REMONTAGEM",
    RESETAR_REMONTAGEM: "entreposto/RESETAR_REMONTAGEM",
    RESETAR: "entreposto/RESETAR",
    RESETAR_MATERIAIS: "entreposto/RESETAR_MATERIAIS",

    ATUALIZAR_DOMINIOS: "entreposto/ATUALIZAR_DOMINIOS",
    ATUALIZAR_ITEM_LISTA_DE_MERCADORIA:
        "entreposto/ATUALIZAR_ITEM_LISTA_DE_MERCADORIA",
    ATUALIZAR_RECONHECIMENTO_ITEM_DE_MERCADORIA:
        "entreposto/ATUALIZAR_RECONHECIMENTO_ITEM_DE_MERCADORIA",
    ATUALIZAR_QUANTIDADE_OPERADORES:
        "entreposto/ATUALIZAR_QUANTIDADE_OPERADORES",
    ATUALIZAR_QUANTIDADE_AJUDANTES: "entreposto/ATUALIZAR_QUANTIDADE_AJUDANTES",
    ATUALIZAR_MATERIAL: "entreposto/ATUALIZAR_MATERIAL",
    ATUALIZAR_MATERIAL_QUANTIDADE: "entreposto/ATUALIZAR_MATERIAL_QUANTIDADE",
    ADICIONAR_MATERIAL: "entreposto/ADICIONAR_MATERIAL",
    REMOVER_MATERIAL: "entreposto/REMOVER_MATERIAL",
    ATUALIZAR_INICIO_OPERACAO: "entreposto/ATUALIZAR_INICIO_OPERACAO",
    ATUALIZAR_FIM_OPERACAO: "entreposto/ATUALIZAR_FIM_OPERACAO",
    ATUALIZAR_MATERIAL_OPERACIONAL: "entreposto/ATUALIZAR_MATERIAL_OPERACIONAL",
    ATUALIZAR_ITENS_LISTA_DE_MERCADORIA:
        "entreposto/ATUALIZAR_ITENS_LISTA_DE_MERCADORIA",
    ATUALIZAR_LOCAL_DE_REMOCAO: "entreposto/ATUALIZAR_LOCAL_DE_REMOCAO",
    ATUALIZAR_LOCAL_DE_POSICIONAMENTO:
        "entreposto/ATUALIZAR_LOCAL_DE_POSICIONAMENTO",
    ATUALIZAR_LOCAL_ID: "entreposto/ATUALIZAR_LOCAL_ID",
    RESETAR_POSICIONAMENTO: "entreposto/RESETAR_POSIONAMENTO",
    ATUALIZAR_SKILLS: "entreposto/ATUALIZAR_SKILLS"
};

/**
 * @type {import("./useEntreposto").Entreposto["state"]}
 */
export const INITIAL = {
    etapa: 1,
    posicionamento: {
        localDeRemocao: "",
        localDePosicionamento: "",
        localId: ""
    },
    remontagem: {
        remontagemId: "",
        dataInicio: "",
        dataFim: "",
        ipaMarimex: "",
        emp: "",
        quadra: "",
        quadraNome: "",
        idRemontagemControle: "",
        operacao: "MAN",
        tempoOperacao: "",
        quantidadeOperadores: "",
        quantidadeAjudantes: "",
        mercadoriaOrigemImagem: [],
        mercadoriaDestinoImagem: [],
        origemAposRemontagemImagem: []
    },
    volumeOrigem: {
        etiqueta: "",
        numeroFormatado: "",
        etiquetaFormatada: "",
        etiquetaResponse: "",
        nodeList: "",
        nodesExpanded: "",
        novaEtiqueta: false,
        id: "",
        embalagemRegular: "",
        embalagemMaster: "",
        tipo: "",
        tipoInicial: "",
        quantidadeRegular: "",
        contraMarca: "",
        comprimento: "",
        largura: "",
        altura: "",
        peso: "",
        localId: "",
        lote: "",
        tipoLocal: EnumTiposLocal.Origem
    },
    volumeDestino: {
        etiqueta: "",
        numeroFormatado: "",
        novaEtiqueta: false,
        id: "",
        embalagemRegular: "",
        embalagemMaster: "",
        tipo: "",
        tipoInicial: "",
        quantidadeRegular: "",
        quantidadeRegularInicial: "",
        contraMarca: "",
        comprimento: "",
        largura: "",
        altura: "",
        peso: "",
        localId: "",
        lote: "",
        tipoLocal: EnumTiposLocal.Destino
    },
    listaDeMercadoria: [],
    dominios: {
        EmbalagemMaster: [],
        EmbalagemRegular: [],
        Empilhadeira: [],
        Localidade: [],
        MaterialOperacional: [],
        TipoStatusVolume: []
    },
    quantidadeOperadores: "",
    quantidadeAjudantes: "",
    materiais: [],
    inicioOperacao: "",
    fimOperacao: "",
    skills: {
        ErrorMessage: "",
        Skills: [],
        ID: 0,
        Perfil: "",
        PodeDigitarEtiqueta: false,
        PodeScannear: false,
        Status: false
    }
};

export default function entrepostoReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesEntreposto.ATUALIZAR_REMONTAGEM:
            return {
                ...state,
                remontagem: Object.assign(
                    {},
                    state.remontagem,
                    action.payload.remontagem
                )
            };
        case TypesEntreposto.RESETAR_REMONTAGEM:
            return {
                ...state,
                remontagem: {
                    remontagemId: "",
                    dataInicio: "",
                    dataFim: "",
                    ipaMarimex: "",
                    emp: "",
                    quadra: "",
                    quadraNome: "",
                    idRemontagemControle: "",
                    operacao: "MAN",
                    tempoOperacao: "",
                    quantidadeOperadores: "",
                    quantidadeAjudantes: "",
                    mercadoriaOrigemImagem: [],
                    mercadoriaDestinoImagem: [],
                    origemAposRemontagemImagem: []
                },
                volumeDestino: {
                    etiqueta: "",
                    novaEtiqueta: false,
                    id: "",
                    embalagemRegular: "",
                    embalagemMaster: "",
                    tipo: "",
                    tipoInicial: "",
                    quantidadeRegular: "",
                    quantidadeRegularInicial: "",
                    contraMarca: "",
                    comprimento: "",
                    largura: "",
                    altura: "",
                    peso: "",
                    localId: "",
                    lote: "",
                    tipoLocal: EnumTiposLocal.Destino
                },
                quantidadeOperadores: "",
                quantidadeAjudantes: "",
                listaDeMercadoria: [],
                materiais: [],
                inicioOperacao: "",
                fimOperacao: ""
            };
        case TypesEntreposto.ATUALIZAR_ITEM_LISTA_DE_MERCADORIA: {
            console.log(action.payload);
            const novaLista = [...state.listaDeMercadoria];
            const index = state.listaDeMercadoria.findIndex(
                ({ id }) => id === action.payload.itemId
            );
            const saldoTotal =
                action.payload?.saldoTotal ?? novaLista[index].saldoTotal;
            novaLista[index][action.payload.campo] = action.payload.valor;
            novaLista[index].saldo = String(
                // arredondando para duas casas decimais
                Math.round(
                    (parseFloat(saldoTotal ?? "0") -
                        parseFloat(
                            isNaN(action.payload.valor) || !action.payload.valor
                                ? "0"
                                : action.payload.valor
                        )) *
                        10000
                ) / 10000
            );
            return {
                ...state,
                listaDeMercadoria: novaLista
            };
        }
        case TypesEntreposto.ATUALIZAR_RECONHECIMENTO_ITEM_DE_MERCADORIA: {
            const novaLista = [...state.listaDeMercadoria];
            const index = state.listaDeMercadoria.findIndex(
                ({ id }) => id === action.payload.itemId
            );
            novaLista[index].reconhecido = action.payload.valor;
            return {
                ...state,
                listaDeMercadoria: novaLista
            };
        }
        case TypesEntreposto.ATUALIZAR_ETAPA:
            return {
                ...state,
                etapa: action.payload.etapa
            };
        case TypesEntreposto.ATUALIZAR_VOLUME_ORIGEM:
            return {
                ...state,
                volumeOrigem: Object.assign(
                    {},
                    state.volumeOrigem,
                    action.payload.volume
                )
            };
        case TypesEntreposto.ATUALIZAR_VOLUME_DESTINO:
            return {
                ...state,
                volumeDestino: Object.assign(
                    {},
                    state.volumeDestino,
                    action.payload.volume
                )
            };
        case TypesEntreposto.ATUALIZAR_QUANTIDADE_REGULAR:
            return {
                ...state,
                quantidadeRegular: action.payload.quantidadeRegular
            };

        case TypesEntreposto.RESETAR:
            return {
                ...INITIAL
            };
        case TypesEntreposto.ATUALIZAR_DOMINIOS:
            return {
                ...state,
                dominios: action.payload.dominios
            };
        case TypesEntreposto.ATUALIZAR_ITENS_LISTA_DE_MERCADORIA: {
            return {
                ...state,
                listaDeMercadoria: action.payload.listaDeMercadoria
            };
        }
        case TypesEntreposto.ATUALIZAR_QUANTIDADE_OPERADORES:
            return {
                ...state,
                quantidadeOperadores: action.payload.quantidadeOperadores
            };
        case TypesEntreposto.ATUALIZAR_QUANTIDADE_AJUDANTES:
            return {
                ...state,
                quantidadeAjudantes: action.payload.quantidadeAjudantes
            };
        case TypesEntreposto.ATUALIZAR_MATERIAL: {
            return produce(state, draft => {
                draft.materiais[action.payload.index].material =
                    action.payload.material;
            });
        }
        case TypesEntreposto.RESETAR_MATERIAL: {
            return {
                ...state,
                materiais: INITIAL.materiais
            };
        }
        case TypesEntreposto.ATUALIZAR_MATERIAL_QUANTIDADE: {
            return produce(state, draft => {
                draft.materiais[action.payload.index].quantidade =
                    action.payload.quantidade;
            });
        }
        case TypesEntreposto.ADICIONAR_MATERIAL: {
            return produce(state, draft => {
                draft.materiais.push({ material: "", quantidade: "" });
            });
        }
        case TypesEntreposto.REMOVER_MATERIAL: {
            return produce(state, draft => {
                draft.materiais.splice(action.payload.index, 1);
            });
        }
        case TypesEntreposto.ATUALIZAR_INICIO_OPERACAO:
            return {
                ...state,
                inicioOperacao: action.payload.inicioOperacao
            };
        case TypesEntreposto.ATUALIZAR_FIM_OPERACAO:
            return {
                ...state,
                fimOperacao: action.payload.fimOperacao
            };
        case TypesEntreposto.ATUALIZAR_MATERIAL_OPERACIONAL:
            return {
                ...state,
                materialOperacional: action.payload.material
            };
        case TypesEntreposto.ATUALIZAR_LOCAL_DE_REMOCAO:
            return {
                ...state,
                posicionamento: {
                    ...state.posicionamento,
                    localDeRemocao: action.payload.local
                }
            };
        case TypesEntreposto.ATUALIZAR_LOCAL_DE_POSICIONAMENTO:
            return {
                ...state,
                posicionamento: {
                    ...state.posicionamento,
                    localDePosicionamento: action.payload.local
                }
            };
        case TypesEntreposto.ATUALIZAR_LOCAL_ID:
            return {
                ...state,
                posicionamento: {
                    ...state.posicionamento,
                    localId: action.payload.localId
                }
            };
        case TypesEntreposto.RESETAR_POSICIONAMENTO:
            return {
                ...state,
                posicionamento: INITIAL.posicionamento
            };
        case TypesEntreposto.ATUALIZAR_SKILLS:
            return {
                ...state,
                skills: action.payload.skills
            };

        default:
            return state;
    }
}

function atualizarEtapa(etapa) {
    return {
        type: TypesEntreposto.ATUALIZAR_ETAPA,
        payload: { etapa }
    };
}

/**
 *
 * @param {Partial<typeof INITIAL.remontagem>} remontagem
 */
function atualizarRemontagem(remontagem) {
    return {
        type: TypesEntreposto.ATUALIZAR_REMONTAGEM,
        payload: { remontagem }
    };
}
function resetarRemontagem() {
    return {
        type: TypesEntreposto.RESETAR_REMONTAGEM
    };
}

/**
 *
 * @param {Partial<import("./useEntreposto").Volume>} volume
 * @returns
 */
function atualizarVolumeOrigem(volume) {
    return {
        type: TypesEntreposto.ATUALIZAR_VOLUME_ORIGEM,
        payload: {
            volume
        }
    };
}

/**
 * @param {Partial<import("./useEntreposto").Volume>} volume
 * @returns
 */
function atualizarVolumeDestino(volume) {
    return {
        type: TypesEntreposto.ATUALIZAR_VOLUME_DESTINO,
        payload: { volume }
    };
}

function resetarMateriais() {
    return {
        type: TypesEntreposto.RESETAR_MATERIAIS
    };
}

function resetarVolumeDestino() {
    return {
        type: TypesEntreposto.ATUALIZAR_VOLUME_DESTINO,
        payload: { volume: INITIAL.volumeDestino }
    };
}

function atualizarQuantidadeRegular(quantidadeRegular) {
    return {
        type: TypesEntreposto.ATUALIZAR_QUANTIDADE_REGULAR,
        payload: { quantidadeRegular }
    };
}

function resetar() {
    return {
        type: TypesEntreposto.RESETAR,
        payload: null
    };
}

function atualizarDominios(dominios) {
    return {
        type: TypesEntreposto.ATUALIZAR_DOMINIOS,
        payload: { dominios }
    };
}

function atualizarRemontagemListaDeMercadoria(id, value) {
    return {
        type: TypesEntreposto.ATUALIZAR_ITEM_LISTA_DE_MERCADORIA,
        payload: {
            itemId: id,
            valor: value,
            campo: "remontado"
        }
    };
}

function atualizarReconhecimentoListaDeMercadoria(id, value) {
    return {
        type: TypesEntreposto.ATUALIZAR_RECONHECIMENTO_ITEM_DE_MERCADORIA,
        payload: { itemId: id, valor: value }
    };
}

function atualizarQuantidadeOperadores(quantidadeOperadores) {
    return {
        type: TypesEntreposto.ATUALIZAR_QUANTIDADE_OPERADORES,
        payload: { quantidadeOperadores }
    };
}

function atualizarQuantidadeAjudantes(quantidadeAjudantes) {
    return {
        type: TypesEntreposto.ATUALIZAR_QUANTIDADE_AJUDANTES,
        payload: { quantidadeAjudantes }
    };
}

function atualizarMaterial(index, material) {
    return {
        type: TypesEntreposto.ATUALIZAR_MATERIAL,
        payload: { index, material }
    };
}

function atualizarMaterialQuantidade(index, quantidade) {
    return {
        type: TypesEntreposto.ATUALIZAR_MATERIAL_QUANTIDADE,
        payload: { index, quantidade }
    };
}

function adicionarMaterial() {
    return {
        type: TypesEntreposto.ADICIONAR_MATERIAL
    };
}

function removerMaterial(index) {
    return {
        type: TypesEntreposto.REMOVER_MATERIAL,
        payload: { index }
    };
}

function atualizarInicioOperacao(inicioOperacao) {
    return {
        type: TypesEntreposto.ATUALIZAR_INICIO_OPERACAO,
        payload: { inicioOperacao }
    };
}
function atualizarFimOperacao(fimOperacao) {
    return {
        type: TypesEntreposto.ATUALIZAR_FIM_OPERACAO,
        payload: { fimOperacao }
    };
}
function resetarPosicionamento() {
    return {
        type: TypesEntreposto.RESETAR_POSICIONAMENTO
    };
}
function atualizarLocalDeRemocao(local) {
    return {
        type: TypesEntreposto.ATUALIZAR_LOCAL_DE_REMOCAO,
        payload: { local }
    };
}
function atualizarLocalDePosicionamento(local) {
    return {
        type: TypesEntreposto.ATUALIZAR_LOCAL_DE_POSICIONAMENTO,
        payload: { local }
    };
}
function atualizarLocalId(localId) {
    return {
        type: TypesEntreposto.ATUALIZAR_LOCAL_ID,
        payload: { localId }
    };
}

function atualizarMaterialOperacional(material) {
    return {
        type: TypesEntreposto.ATUALIZAR_MATERIAL_OPERACIONAL,
        payload: { material }
    };
}

function atualizarItensListaDeMercadoria(mercadoria) {
    return {
        type: TypesEntreposto.ATUALIZAR_ITENS_LISTA_DE_MERCADORIA,
        payload: { listaDeMercadoria: mercadoria }
    };
}

function resetarListaMercadoria() {
    return {
        type: TypesEntreposto.ATUALIZAR_ITENS_LISTA_DE_MERCADORIA,
        payload: { listaDeMercadoria: INITIAL.listaDeMercadoria }
    };
}

function atualizarSkills(skills) {
    return {
        type: TypesEntreposto.ATUALIZAR_SKILLS,
        payload: { skills }
    };
}

function resetVolumeDestino() {
    return {
        type: TypesEntreposto.ATUALIZAR_VOLUME_DESTINO,
        payload: { volume: INITIAL.volumeDestino }
    };
}

function resetVolumeOrigem() {
    return {
        type: TypesEntreposto.ATUALIZAR_VOLUME_ORIGEM,
        payload: { volume: INITIAL.volumeOrigem }
    };
}

export const EntrepostoActions = {
    resetarMateriais,
    atualizarEtapa,
    atualizarVolumeOrigem,
    atualizarVolumeDestino,
    atualizarRemontagem,
    resetar,
    resetVolumeDestino,
    resetVolumeOrigem,
    atualizarDominios,
    atualizarRemontagemListaDeMercadoria: atualizarRemontagemListaDeMercadoria,
    atualizarItensListaDeMercadoria,
    atualizarQuantidadeRegular,
    atualizarQuantidadeOperadores,
    atualizarQuantidadeAjudantes,
    atualizarMaterial,
    atualizarMaterialQuantidade,
    adicionarMaterial,
    removerMaterial,
    atualizarInicioOperacao,
    atualizarFimOperacao,
    atualizarMaterialOperacional,
    resetarPosicionamento,
    atualizarLocalDeRemocao,
    atualizarLocalDePosicionamento,
    atualizarLocalId,
    resetarListaMercadoria,
    atualizarSkills,
    resetarRemontagem,
    resetarVolumeDestino,
    atualizarReconhecimentoListaDeMercadoria
};
